export const GoogleMapApiConfig = 'AIzaSyAoRwX4o9snYfAZZNRtmdcV8381-XKmxhg';